import { ContextService } from '../services/context_service';
import { getTabRechte } from './getTabRechte';

export class Routing {

    protected contextService: ContextService;
    protected disabled: string[] = [];
    protected prefix: string;
    protected routing: any = {};
    protected tabIndex: string;
    protected tabName: string;
    protected tabs: string[] = [];

    constructor(Component: any) {
        this.contextService = Component.contextService;
        this.disabled = Component.disabled || [];
        this.prefix = Component.prefix || null;
        this.routing = (Component.props || {}).routing || {};
        this.tabIndex = Component.tabIndex || null;
        this.tabName = Component.tabName || null;
        this.tabs = Component.tabs || [];
    }

    public init(callback: (rechte: any, tabIndex: number) => void): void {
        const data: any = getTabRechte(
            { disabled: this.disabled, prefix: this.prefix, tabs: this.tabs },
            { key: this.tabIndex, service: this.contextService }
        ) || {};
        const path: any = (JSON.parse(JSON.stringify(this.routing)) || {}).path || {};
        const rechte: any = data.rechte || {};
        const tabIndex: number = rechte[this.tabs[path[this.tabName]] || null] ? path[this.tabName] : data.tabIndex;

        if (data.tabIndex !== null && typeof callback === 'function') {
            callback(rechte, tabIndex);
        }
    }
}
